import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Layout from './components/layout/Layout';
import HeroSection from './components/sections/venture/HeroSection';
import AboutSection from './components/sections/venture/AboutSection';
import PortfolioSection from './components/sections/venture/PortfolioSection';
import ContactSection from './components/sections/venture/ContactSection';
import PolicySection from './components/sections/PolicySection';
import './App.css';

gsap.registerPlugin(ScrollTrigger);

function VenturePage() {
  useEffect(() => {
    // Initialize any global animations or effects
    const sections = document.querySelectorAll('section');
    
    sections.forEach(section => {
      ScrollTrigger.create({
        trigger: section,
        start: 'top 80%',
        end: 'bottom 20%',
        toggleClass: { targets: section, className: 'active' }
      });
    });

    return () => {
      // Clean up ScrollTrigger when component unmounts
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <Layout>
      <HeroSection />
      <AboutSection />
      <PortfolioSection />
      <ContactSection />
      <PolicySection />
    </Layout>
  );
}

export default VenturePage;